<template>
    <div class="p-2 text-dark">
        <h5 class="font-weight-normal text-dark">
            {{ $t('setDeliveryDomain') }}
        </h5>
        <p class="text-description text-dark">
            {{ $t('setDeliveryDomainDespt') }}
        </p>

        <div class="mt-3 form-group">
            <label for="shop-url-browser" class="sr-only">
                {{ $t('setDeliveryDomain') }}
            </label>
            <span class="text-description text-danger">
                * {{ $t('setDeliveryDomainDespt2') }}
            </span>
            <CAlert class="mt-2" v-if="alertText" color="danger">{{ alertText }}</CAlert>
            <CAlert class="mt-2" v-if="successText" color="success">{{ successText }}</CAlert>

            <!-- Browser Access -->
            <h6 class="mt-3">{{ $t('viaBrowserAccess') }}</h6>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <div class="input-group-text">{{ baseURL }}/delivery/</div>
                </div>
                <input id="shop-url-browser" type="text" class="form-control" :readonly="hasPathUniqueName"
                    v-model="shopURL" :placeholder="$t('setDeliveryDomain')" style="min-width: 200px;"
                    @input="onInput" />
                <CButton color="secondary" @click="copyURL(`${baseURL}/delivery/${shopURL}`)"
                    style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    {{ $t('copy') }}
                </CButton>
            </div>
            <div v-if="shopURL" >
                <div class="qr-box-wrapper p-3">
                    <div class=" align-items-center text-center">
                    <div class="text-center qr-container p-2"  ref="qrWrapper" >
                        <QrcodeVue
                        ref="qrCanvas"
                        :value="fullShopURL"
                        :size="150"
                        tag="canvas"
                        />
                        <img
                            class="qr-logo"
                            src="/silom_new_icon.png"
                            alt="logo"
                        />

                        <!-- <p class="mt-2 text-muted" style="font-size: 0.9rem;">
                        {{ fullShopURL }}
                        </p> -->
                    </div>
                    <CButton color="secondary" @click="downloadQRCode" class="mt-1"> 
                            <CIcon name="cilCloudDownload" class="mr-1" />  ดาวน์โหลด QR Code
                        </CButton>
                    </div>
                </div>
            </div>

            <!-- LINE Rich Menu -->
            <h6 class="mt-3">{{ $t('viaLIFFAccess') }}</h6>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <div class="input-group-text">https://liff.line.me/{{ liffId }}/?shop=</div>
                </div>
                <input id="shop-url-line" type="text" class="form-control" readonly v-model="shopURL"
                    :placeholder="$t('setDeliveryDomain')" style="min-width: 200px;" />
                <CButton color="secondary" @click="copyURL(`https://liff.line.me/${liffId}/?shop=${shopURL}`)"
                    style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    {{ $t('copy') }}
                </CButton>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex gap-2 justify-content-between mt-4 align-items-center">
            <div>
                <h6 style="text-decoration: underline;cursor: pointer;">
                    <i class="fi fi-rr-interrogation mr-1"></i>
                    {{ $t('userManualSoftKioks') }}
                </h6>
            </div>
            <div v-if="!hasPathUniqueName">
                <CButton class="pl-5 pr-5 mr-2" color="secondary" @click="cancelEdit">
                    {{ $t('cancel') }}
                </CButton>
                <CButton color="success" class="pl-5 pr-5" :disabled="!shopURL || hasPathUniqueName || loading"
                    @click="submitShopURL">
                    <CSpinner v-if="loading" color="white" size="sm" />
                    {{ $t('save') }}
                </CButton>
            </div>
            <div v-else>
                {{ $t('editDomainContactStaff') }}
                <img style="cursor: pointer;" @click="contactStaff()" class="ml-2" src="/img/line-icon.png"
                    width="30px">
            </div>
        </div>
    </div>
</template>

<script>
import pos from '@/services/local'
import QrcodeVue  from 'qrcode.vue';
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            shopURL: '',
            originalShopURL: '',
            hasPathUniqueName: false,
            loading: false,
            orderShopCollection: null,
            datashop: {},
            baseURL: process.env.VUE_APP_QR_ORDER_WEB_URL,
            liffId: process.env.VUE_APP_LIFF_ID_SOFT_KIOSK,
            alertText: null,
            successText: null,
        };
    },
    components: {
        QrcodeVue
    },
    computed: {
        fullShopURL() {
            return `${this.baseURL}/delivery/${this.shopURL}`;
        }
    },
    mounted() {
        this.loadOrderShopSetting();
    },
    methods: {
        downloadQRCode() {
            const qrWrapper = this.$refs.qrWrapper;
            if (!qrWrapper) {
                console.error('❌ ไม่พบองค์ประกอบ QR เพื่อแปลงเป็นภาพ');
                return;
            }

            html2canvas(qrWrapper, {
                backgroundColor: null, // preserve transparency if needed
                useCORS: true // เผื่อโหลดโลโก้ข้าม origin
            }).then(canvas => {
                const link = document.createElement('a');
                link.download = `qr-${this.shopURL || 'shop'}.png`;
                link.href = canvas.toDataURL('image/png');
                link.click();
            }).catch(err => {
                console.error('เกิดข้อผิดพลาดขณะสร้างภาพ QR:', err);
            });
            // const qrComponent = this.$refs.qrCanvas;
            // const canvas = qrComponent?.$el?.querySelector('canvas');
            // console.log(canvas);
            
            // if (!canvas || typeof canvas.toDataURL !== 'function') {
            //     console.error('❌ ไม่พบ canvas หรือไม่รองรับ toDataURL');
            //     return;
            // }

            // const imgData = canvas.toDataURL('image/png');
            // const a = document.createElement('a');
            // a.href = imgData;
            // a.download = `qr-download.png`;
            // a.click();
        },
        onInput() {
            this.shopURL = this.shopURL.replace(/[^a-z]/g, '').slice(0, 20);
        },
        copyURL(fullURL) {
            navigator.clipboard.writeText(fullURL).then(() => {
                this.$toast?.success(this.$t('copiedSuccess') || 'Copied!');
            }).catch(() => {
                this.$toast?.error(this.$t('copyFailed') || 'Copy failed');
            });
        },
        cancelEdit() {
            this.shopURL = this.originalShopURL;
            this.$emit('soft-kiosk')
        },
        async loadOrderShopSetting() {
            const uid = localStorage.getItem('uid');
            const shopObjectId = localStorage.getItem('shopObjectId');

            try {
                const res = await pos({
                    method: 'get',
                    url: '/api/v3.0/shop/ordershopsetting',
                    params: { shopObjectId },
                    headers: { shopObjectId }
                });

                this.orderShopCollection = res?.data?.data || null;
                this.shopURL = this.orderShopCollection?.pathUniqueName || '';
                this.originalShopURL = this.shopURL;
                this.hasPathUniqueName = !!this.shopURL;

                // Assume datashop is available in Vuex or props
                this.datashop = this.orderShopCollection?.shop || {};
            } catch (err) {
                console.error('Failed to load shop settings', err);
            }
        },
        async submitShopURL() {
            this.loading = true;
            const uid = localStorage.getItem('uid');
            const shopObjectId = localStorage.getItem('shopObjectId');
            const projectPath = ['home', 'menulists', 'MyCart', 'user', 'history', 'tracking', 'order-details', 'notification', 'payment-gateway']


            try {
                if (!this.hasPathUniqueName) {
                    if (projectPath.includes(this.shopURL)) {
                        this.alertText = this.$t('restrictPathUniqueName')
                        setTimeout(() => {
                            this.alertText = null
                        }, 3000);
                        return
                    }

                    const checkRes = await pos({
                        method: 'get',
                        url: '/api/v3.0/shop/check/path/uniquename',
                        headers: { uniqueName: this.shopURL },
                    });

                    if (checkRes.data?.data?.isUsed) {
                        this.alertText = this.$t('domianInUsed')
                        setTimeout(() => {
                            this.alertText = null
                        }, 3000);

                        this.loading = false;
                        return;
                    }
                }

                const data = {
                    shop: {
                        objectId: shopObjectId,
                        id: this.datashop.id,
                        branchName: this.datashop.branchName,
                    },
                    shopId: this.datashop.id,
                    uid: uid,
                    pathUniqueName: this.shopURL,
                };

                const objectIdToUse = this.orderShopCollection?.objectId || shopObjectId;
                await pos({
                    method: 'patch',
                    url: `/api/v2.0/${uid}/OrderShopSetting/${objectIdToUse}`,
                    data: data,
                });

                this.originalShopURL = this.shopURL;
                this.hasPathUniqueName = true;
                this.successText = this.$t('saveSuccess')
                setTimeout(() => {
                    this.successText = null
                }, 3000);

            } catch (error) {
                console.error(this.$t('saveFailed') || 'Save failed');
            } finally {
                this.loading = false;
            }
        },
        contactStaff() {
            window.open('https://liff.line.me/1645278921-kWRPP32q/?accountId=silompos', '_blank');
        }

    }
};
</script>

<style scoped>
.link-box {
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 10px;
    border: 1px solid #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
}
.qr-box-wrapper {
  background-color: #f9f9f9; /* สีพื้นหลัง */
  border: 1px solid #dee2e6; /* เส้นขอบบางๆ */
  border-radius: 5px;       /* มุมโค้ง */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* เงา */
}
.qr-container {
  position: relative;
  /* width: 150px;
  height: 150px; */
  margin: 0 auto;
}

.qr-container canvas {
  width: 100%;
  height: 100%;
}

.qr-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30px;
  height: 30px;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  background: white;
  padding: 2px;
}

</style>
